import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
  cnxExist: boolean = true;
  lang: string = "de"; 
  platform = "ios"; 
}